/* @flow */

export const roles: Array<{ text: string, value: number, org?: boolean }> = [
  { text: "System Admin", value: 1 },
  { text: "System Read-only User", value: 2 },
  { text: "Admin", value: 4, org: true },
  { text: "Manager", value: 8, org: true },
  { text: "Read-only User", value: 16, org: true },
];

export const passwordExpirationOptions = [
  { text: "Never", value: -1 },
  { text: "3 months", value: 7884009 },
  { text: "6 months", value: 15768017 },
  { text: "1 year", value: 31556926 },
];

export const sessionExpirationOptions = [
  { text: "Never", value: -1 },
  { text: "1 hour", value: 10800 },
  { text: "24 hours", value: 86400 },
  { text: "1 week", value: 604800 },
  { text: "1 month", value: 2629744 },
];

export const sysAdmin = function () {
  return this.$store.getters.currentUser.roles_mask === 1;
};

export const sysRo = function () {
  return this.$store.getters.currentUser.roles_mask === 2;
};

export const orgAdmin = function () {
  return this.$store.getters.currentUser.roles_mask === 4;
};

export const readOnlyUser = function () {
  return (
    this.$store.getters.currentUser.roles_mask === 16 ||
    this.$store.getters.currentUser.roles_mask === 2
  );
};

export const orgManager = function () {
  return this.$store.getters.currentUser.roles_mask === 8;
};

export const computePaginateSortFilterParams = (params: {
  sortModel: [],
  filterModel: {},
  startRow: number,
  endRow: number,
}) => {
  if (!params || !Object.keys(params).length) return {};
  const { sortModel = [], filterModel = {}, startRow, endRow } = params;
  const sortString = sortModel
    .map(({ sort, colId }) => {
      let sortString = "";

      if (sort === "desc") sortString += "-";

      switch (colId) {
        case "dev_eui":
        case "end_device_eui":
          // Sort first by name, then by EUI
          sortString += "end_device.name,";
          if (sort === "desc") sortString += "-";
          sortString += colId;
          break;
        case "gw_eui":
          // Sort first by name, then by EUI
          sortString += "gateway.name,";
          if (sort === "desc") sortString += "-";
          sortString += colId;
          break;
        case "application_network_id":
          sortString += "application_network.name";
          break;
        case "app_eui":
          sortString += "application_network.name";
          break;
        default:
          sortString += colId;
      }

      return sortString;
    })
    .join(",");

  const filters = {};
  for (const key in filterModel) {
    filters[`q[${key}]`] = filterModel[key].filter;
  }

  return {
    skip: startRow,
    limit: endRow - startRow,
    sort: sortString,
    ...filters,
  };
};

export const nullifyBlankStrings = (obj) => {
  for (let k of Object.keys(obj)) {
    if (obj[k] === "") {
      obj[k] = null;
    }
  }
};

export const computedCollectionCount = ({
  endRow,
  collectionCount,
  filteredCount,
}: {
  endRow: number,
  collectionCount: number,
  filteredCount?: number,
}) => {
  if (typeof filteredCount === "number" && endRow > filteredCount) {
    // Scrolled to last block, so return collectionCount to cap table at last row
    return filteredCount;
  } else if (endRow > collectionCount) {
    // Scrolled to last block, so return collectionCount to cap table at last row
    return collectionCount;
  }

  // Don't return collectionCount so scrolling is capped to loaded rows
  // If we returned a collectionCount here, you could scroll to end of collection without any of the data being loaded yet
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/api.js